import React from "react";
import styled from "styled-components";

export default styled.h4`
    color: #5562C0;
    font-size: 27px;
    font-weight: 700;
    float: left;
    margin: 0;
    margin-left: 45px;
    width: 100%;
`;